import { render, staticRenderFns } from "./reportNoFeeRoomList.vue?vue&type=template&id=64c521da&scoped=true"
import script from "./reportNoFeeRoomList.vue?vue&type=script&lang=js"
export * from "./reportNoFeeRoomList.vue?vue&type=script&lang=js"
import style0 from "./reportNoFeeRoomList.vue?vue&type=style&index=0&id=64c521da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c521da",
  null
  
)

export default component.exports